module.exports = require("@cimpress/react-components/lib/shapes/Spinner");